var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"1.168.7"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

import projectConfig from './package.json';
import { shouldDropSentryEvent } from 'utils/sentryShouldDropEvent';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  normalizeDepth: 10,
  environment: process.env.SENTRY_ENV,
  release: process.env.SENTRY_RELEASE || projectConfig.version,
  tracesSampleRate: 0,
  enableTracing: false,
  beforeSend: (event: Sentry.Event, hint: Sentry.EventHint) =>
    shouldDropSentryEvent(event, hint) ? null : event,
});
